export const breadcrumb = [
    {
      href: '/runiverse',
      title: 'Tools',
      isActive: false,
    },
    {
      href: '/runiverse/spells',
      title: 'Spells',
      isActive: false,
    },
    {
      href: '/runiverse/equipment',
      title: 'Equipment',
      isActive: false,
    },
    {
      href: '/runiverse/monster-drops',
      title: 'Monster Drops',
      isActive: false,
    },
    {
      href: '/runiverse/resources',
      title: 'Resource Finder',
      isActive: false,
    },
    {
      href: '/runiverse/level-up-guide',
      title: 'Level Up Guide',
      isActive: false,
    },
    {
      href: '/runiverse/status-effects',
      title: 'Status Effects',
      isActive: false,
    },
  ];

export const pixelsBreadcrumb = [
    {
      href: '/pixels/land-inventory',
      title: 'Lands',
      isActive: false,
    },
    {
      href: '/pixels/animal/drops',
      title: 'Animal Drops',
      isActive: false,
    },
    {
      href: '/pixels/quest/alchemist-concoction',
      title: 'Quests',
      isActive: false,
    },
  ];


  
  
  
  
